import React, { useState, useEffect, useRef } from "react";
import { Link, BrowserRouter as Router, Route } from "react-router-dom";
import "./style.scss";
import {
  getRouting,
  digitToRupeeNotation,
} from "../../../../../utils/common";
import { PieChart } from "react-minimal-pie-chart";
import { NumericFormat } from "react-number-format";

const GoalCalculator = (props) => {
  const {
    IAPdata,
  } = props;
  const titledata = IAPdata;

  const [amountGoal, setamountGoal] = useState(2000);
  const [noofYears, setnoofYears] = useState(15);
  const [expectedReturn, setexpectedReturn] = useState(8);
  const [totalSIP, settotalSIP] = useState(0);
  const [totalCost, settotalCost] = useState(0);
  const [totalPiePercent, settotalPiePercent] = useState(0);
  const [amountErr, setamountErr] = useState(false);
  const [rateErr, setrateErr] = useState(false);
  const [timeErr, settimeErr] = useState(false);
 

  useEffect(() => {
    const totalSipValue = goalCalculator(
      amountGoal,
      expectedReturn,
      noofYears
    );
    settotalSIP(Math.round(totalSipValue));
  }, []);

  const handleAmountGoal = (event) => {
    const totalGoldAmount = parseFloat(event.target.value.replace(/,/g, ""));

    if (totalGoldAmount % 1000) {
      setamountGoal(totalGoldAmount);
      setamountErr(true);
    } else if (totalGoldAmount > 500000000 || totalGoldAmount < 1000) {
      setamountGoal(totalGoldAmount);
      setamountErr(true);
    } else {
      setamountGoal(totalGoldAmount);
      setamountErr(false);

      const totalSipValue = goalCalculator(
        totalGoldAmount,
        expectedReturn,
        noofYears
      );
      settotalSIP(Math.round(totalSipValue));
    }
  };

  const handlenoofYears = (event) => {
    const re = /^[0-9.\b]+$/;

    // if value is not blank, then test the regex

    if (event.target.value === "" || re.test(event.target.value)) {
      if (event.target.value > 50 || event.target.value < 1) {
        setnoofYears(event.target.value);
        settimeErr(true);
        //const totalSipValue = inflationCalculator(monthAmount, 1, yearExpense);
      } else {
        settimeErr(false);
        setnoofYears(event.target.value);
        const totalSipValue = goalCalculator(
          amountGoal,
          expectedReturn,
          event.target.value
        );
        settotalSIP(Math.round(totalSipValue));
      }
    }
  };

  const handleexpectedReturn = (event) => {
    const re = /^[0-9.\b]+$/;

    // if value is not blank, then test the regex

    if (event.target.value === "" || re.test(event.target.value)) {
      if (event.target.value > 13 || event.target.value < 2) {
        setexpectedReturn(event.target.value);
        setrateErr(true);
        //const totalSipValue = inflationCalculator(monthAmount, 1, yearExpense);
      } else {
        setexpectedReturn(event.target.value);
        setrateErr(false);
        const totalSipValue = goalCalculator(
          amountGoal,
          event.target.value,
          noofYears
        );
        settotalSIP(Math.round(totalSipValue));
      }
    }
  };

  function goalCalculator(amountGoal, expectedReturn, noofYears) {
    let timePeriod = 12,
      i = expectedReturn / (timePeriod * 100),
      n = noofYears * timePeriod,
      amountForGoal = Math.round(amountGoal * Math.pow(1.07, noofYears));
    settotalCost(amountForGoal);

    let returnValue =
      amountForGoal / (((Math.pow(1 + i, n) - 1) / i) * (1 + i));

    if (isNaN(returnValue)) {
      returnValue = 0;
    }

    const totalPieValue = returnValue + amountForGoal;

    settotalPiePercent(Math.round(totalPieValue));

    return returnValue;
  }

  let smallPie = "";
  let bigPie = "";
  if (amountErr === false && rateErr === false && timeErr === false) {
    smallPie = (totalCost / totalPiePercent) * 100;
    bigPie = (totalSIP / totalPiePercent) * 100;
  } else {
    smallPie = 0;
    bigPie = 0;
  }

  return (
      <section className="inflationtoolsdiv">
        <div className="container">
          <div className="row my-5 gx-5">
            <div className="col-md-6">
              <div className="toolsfirstdiv me-md-3">
                <h2 className="mb-3"><span>Goal</span> SIP</h2>
                {/* <p className="mb-5">
                  Find out how much you need to invest to achieve your goal
                  using our Goal SIP Planner.
                </p> */}
                <div className="mb-4">
                  <div className="align-items-center row mb-3">
                    <div className="col-7 text-break">
                      <h4>Amount I would need to achieve this goal today</h4>
                    </div>
                    <div className="col-5 d-flex justify-content-end">
                      <NumericFormat
                        type="text"
                        className="amtwidth"
                        placeholder="₹ 0"
                        onInput={handleAmountGoal}
                        value={amountGoal}
                        thousandSeparator={","}
                        thousandsGroupStyle="lakh"
                        decimalSeparator={"."}
                      />
                    </div>
                    <div className="col-8">&nbsp;</div>
                    {amountErr ? (
                      <div className="col-12 d-flex justify-content-end errortext">
                        <span style={{ color: "red", fontSize: 12 }}>
                          Value should be between 1,000 - 50,00,00,000 &
                          multiples of 1,000
                        </span>
                      </div>
                    ) : null}
                  </div>
                  {/* <div>
                    <input
                      type="range"
                      className="w-100"
                      min="1000"
                      max="500000000"
                      value={amountGoal}
                      onChange={handleAmountGoal}
                    />
                    <div className="d-flex justify-content-between startendval">
                      <span>1,000</span>
                      <span>50,00,00,000</span>
                    </div>
                  </div> */}
                </div>
                <div className="mb-4">
                  <div className="align-items-center row mb-3">
                    <div className="col-7 text-break">
                      <h4>Number of years to fulfill this goal</h4>
                    </div>
                    <div className="col-5 d-flex justify-content-end">
                      <input
                        type="text"
                        className="amtwidth"
                        placeholder="Enter Years"
                        value={noofYears}
                        onChange={handlenoofYears}
                        maxLength={2}
                      />
                    </div>
                    <div className="col-8">&nbsp;</div>
                    {timeErr ? (
                      <div className="col-12 d-flex justify-content-end errortext">
                        <span style={{ color: "red", fontSize: 12 }}>
                          Value should be between 1 to 50
                        </span>
                      </div>
                    ) : null}
                  </div>
                  <div>
                    <input
                      type="range"
                      className="w-100"
                      min="1"
                      max="50"
                      value={noofYears}
                      onChange={handlenoofYears}
                    />
                    <div className="d-flex justify-content-between startendval">
                      <span>1 Year</span>
                      <span>50 Years</span>
                    </div>
                  </div>
                </div>
                <div className="mb-4">
                  <div className="align-items-center row mb-3">
                    <div className="col-7 text-break">
                      <h4>Expected rate of return</h4>
                    </div>
                    <div className="col-5 d-flex justify-content-end">
                      <input
                        type="text"
                        className="amtwidth"
                        placeholder="0%"
                        value={expectedReturn}
                        onChange={handleexpectedReturn}
                        maxLength={2}
                      />
                    </div>
                    <div className="col-8">&nbsp;</div>
                    {rateErr ? (
                      <div className="col-12 d-flex justify-content-end errortext">
                        <span style={{ color: "red", fontSize: 12 }}>
                          Value should be between 2 to 13
                        </span>
                      </div>
                    ) : null}
                  </div>
                  <div>
                    <input
                      type="range"
                      className="w-100"
                      min="2"
                      max="13"
                      value={expectedReturn}
                      onChange={handleexpectedReturn}
                    />
                    <div className="d-flex justify-content-between startendval">
                      <span>2 %</span>
                      <span>13 %</span>
                    </div>
                  </div>
                </div>
              </div>
              {smallPie && bigPie ? (
                <div className="currentandfuture">
                  <div className="row">
                    <div className="col-6">
                      <p className="text">Total Cost</p>
                      <p className="cfamount my-2">
                        ₹ {digitToRupeeNotation(totalCost)}
                      </p>
                    </div>
                    <div className="col-6">
                      <p className="text">Save/month</p>
                      <p className="cfamount my-2">
                        ₹ {digitToRupeeNotation(totalSIP)}
                      </p>
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>

            <div className="col-md-6 buttondiv">
              <div className="ms-md-3">
                <div className="w-50 w-50 mx-auto mb-4">
                  <PieChart
                    data={[
                      {
                        title: "Total Cost",
                        value: smallPie,
                        color: "rgba(27, 75, 134)",
                      },
                      {
                        title: "Save/Month",
                        value: bigPie,
                        color: "rgba(214, 214, 214, 0.7)",
                      },
                    ]}
                    lineWidth={35}
                  />
                </div>
              </div>
              {smallPie && bigPie ? (
                <div className="row justify-content-center my-4">
                  <div md={9}>
                    <div className="d-flex align-items-center justify-content-between">
                      <div className="d-flex align-items-center">
                        <div className="piecolor"></div>
                        <p>Save/Month</p>
                      </div>
                      <div className="d-flex align-items-center">
                        <div className="piecolor1"></div>
                        <p>Total Cost</p>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}
              {/* {titledata && titledata.buttonText ? 
              <a href="#callbackform" className="callbackdiv">
                <div className="callback">{titledata && titledata.buttonText}</div>
              </a>
              :''} */}
            </div>
          </div>
        </div>
      </section>
  );
};

export default GoalCalculator;
